import { useTranslation } from "react-i18next";
import type { ProposalLineItemDto } from "@tc/shared";
import { Card, CardTitle, Icon, OptionList, OptionRow } from "@/components/ui";
import { useFormatters } from "@/lib/i18n/format";

/**
 * The trip options the club did NOT select when it accepted the proposal (TRAV-66). Rendered below
 * the agreed-scope breakdown for both club and back-office users, as a read-only list — no total row
 * (these lines are not part of the price). Renders nothing when the club kept every option.
 */
export function UnselectedOptionsCard({
  lines,
  currency,
}: {
  lines: ProposalLineItemDto[];
  currency: string;
}) {
  const { t } = useTranslation();
  const fmt = useFormatters();
  if (lines.length === 0) return null;
  return (
    <Card>
      <div className="row-between" style={{ alignItems: "center" }}>
        <CardTitle>{t("proposal.notSelectedTitle")}</CardTitle>
        <Icon name="x" size={18} className="faint" />
      </div>
      <p className="sub" style={{ margin: "6px 0 0" }}>{t("proposal.notSelectedDesc")}</p>
      <OptionList style={{ marginTop: 14 }}>
        {lines.map((line) => (
          <OptionRow
            key={line.id}
            description={line.description}
            qtyLabel={`${line.qty} × ${fmt.currency(line.unitPrice, currency)}`}
            amountLabel={fmt.currency(line.amount, currency)}
          />
        ))}
      </OptionList>
    </Card>
  );
}
